import { initListener } from './app/services/ApiService';

// =========================
// DIRECTIVES
// =========================
import './app/directives/pageDesign/popover';
import './app/directives/pageDesign/tooltip';

// =========================
// FILTERS
// =========================
import './app/filters/propertySurchargeSum.filter';

const Vue = window.Vue;

// =========================
// COMPONENTS
// =========================
Vue.component('AddItemToBasketOverlayMatrix', () => import('./app/components/basket/AddItemToBasketOverlay.vue'));
Vue.component('MatrixAddToBasket', () => import('./app/components/basket/MatrixAddToBasket.vue'));
Vue.component('MatrixGraduatedPrices', () => import('./app/components/item/MatrixGraduatedPrices.vue'));
Vue.component('MatrixVariationItem', () => import('./app/components/item/MatrixVariationItem.vue'));
Vue.component('MatrixVariations', () => import('./app/components/item/MatrixVariations.vue'));
Vue.component('MatrixQuantityInput', () => import('./app/components/item/QuantityInput.vue'));

initListener();

$(function () {
  $(document).on('click', '.popover .cancel', function () {
    $(this).parents('.popover').popover('hide');
  });
});
